export const getMSALAccessToken = () => {
    const token = localStorage.getItem(process.env.REACT_APP_MSAL_TOKEN_KEY);
    if (token !== null && token !== undefined) {
      return JSON.parse(
        localStorage.getItem(
          JSON.parse(
            localStorage.getItem(process.env.REACT_APP_MSAL_TOKEN_KEY)
          ).accessToken[0]
        )
      ).secret;
    }
  };

